<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Restricción de Visualización de Documentos</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          @click="openModalAddUserRestrictedDocuments(null)"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4 mx-3"
        >
          <i class="mdi mdi-account-plus me-1"></i>
          Agregar usuario
        </v-btn>
        <v-btn
          @click="openModalFilterUserRestrictedDocuments()"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4"
        >
          <i class="mdi mdi-filter me-1"></i>
          Filtros
        </v-btn>
      </v-col>

      <v-col cols="12" md="12" sm="12" class="mb-2">
        <p class="text-info">
          <v-icon class="me-1" color="info" size="20">
            mdi-information-outline
          </v-icon>
          <b></b>
          Este mantenedor permite limitar la visualización de documentos a solo
          los usuarios que esten en el listado
        </p>

        <v-data-table
          :page.sync="filters.page"
          :headers="tableHeaders"
          :items="
            restrictedUsersDocuments.items ? restrictedUsersDocuments.items : []
          "
          item-key="code"
          :items-per-page="filters.items"
          class="elevation-1"
          mobile-breakpoint="993"
          hide-default-footer
          :loading="loading"
          @update:sort-by="updateSortBy"
          @update:sort-desc="updateSortDesc"
          :custom-sort="customSort"
          no-data-text="No hay usuarios actualmente habilitados"
          loading-text="Cargando Usuarios... Espere Por favor"
        >
          <template v-slot:item.name="{ item }">
            <div class="text-left">
              {{ item.full_name }}
            </div>
          </template>
          <template v-slot:item.email="{ item }">
            <div class="">
              {{ item.email }}
            </div>
          </template>
          <template v-slot:item.rut="{ item }">
            <div class="">
              {{ item.rut }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex align-items-center justify-content-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="deleteUserRestrictedDocuments(item)"
                    icon
                    color="red darken-2"
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    class="mx-2"
                  >
                    <v-icon> mdi-account-remove </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Usuario</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="filters.page"
            :length="
              restrictedUsersDocuments
                ? restrictedUsersDocuments.total_pages
                : 1
            "
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <modal-add-user-restriction
      ref="modalAddUserRestriction"
      :modalAction="dialogAddUserRestriction"
      :closeModalAddUserRestriction="closeModalAddUserRestriction"
      @userAdded="getUserRestrictedDocumentsData(filters.page)"
    >
    </modal-add-user-restriction>
    <filters
      :modalAction="dialogFilterUserRestrictedDocuments"
      :closeModalFilterUserRestrictedDocuments="
        closeModalFilterUserRestrictedDocuments
      "
      @clearAllFilters="clearAllFilters"
      @searchFilters="searchFilters"
    >
    </filters>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalAddUserRestriction from "./ModalAddUserRestriction.vue";
import { authUsuarioComputed } from "@/state/helpers";
import Filters from "./Filters.vue";
import config from "@/config";
export default {
  components: { ModalAddUserRestriction, Filters },
  data() {
    return {
      dialogAddUserRestriction: false,
      dialogFilterUserRestrictedDocuments: false,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceTime: 500,
      filters: {
        page: 1,
        items: 10,
        filter: "",
        sort_by: "created_at",
        sort_order: "desc",
      },
      tableHeaders: [
        {
          value: "name",
          text: "Nombre",
          sortable: true,
          width: "15%",
        },
        {
          value: "email",
          text: "Correo electrónico",
          sortable: true,
          width: "10%",
          align: "center",
        },
        {
          text: "RUT",
          align: "center",
          sortable: true,
          value: "rut",
          width: "10%",
        },
        {
          value: "actions",
          sortable: false,
          align: "center",
          text: "Acciones",
          width: "10%",
        },
      ],
    };
  },
  mounted() {
    this.getUserRestrictedDocumentsData();
  },
  methods: {
    ...mapActions({
      getUserRestrictedDocuments: "document/getUserRestrictedDocuments",
      changeUserRestrictionDocuments: "document/changeUserRestrictionDocuments",
    }),
    searchFilters(filters) {
      this.filters.filter = filters.filter;
      this.filters.items = filters.items;
      this.getUserRestrictedDocumentsData();
    },
    clearAllFilters() {
      this.filters.filter = null;
      this.filters.items = 10;
      this.getUserRestrictedDocumentsData();
    },
    async getUserRestrictedDocumentsData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = await setTimeout(async function() {
        self.loading = true;
        self.filters.page = page;
        await self.getUserRestrictedDocuments({
          password: config.password_manteiners,
          page: self.filters.page - 1,
          items: self.filters.items,
          filter: self.filters.filter,
          sort_by: self.filters.sort_by,
          sort_order: self.filters.sort_order,
          document_viewer: true,
        });
        self.loading = false;
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by = sortBy;
        this.filters.sort_order = "asc";
        await this.getUserRestrictedDocumentsData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getUserRestrictedDocumentsData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getUserRestrictedDocumentsData();
      }
    },
    customSort(items, index, isDesc, column) {
      return items;
    },
    openModalAddUserRestrictedDocuments() {
      this.dialogAddUserRestriction = true;
    },
    closeModalAddUserRestriction() {
      this.dialogAddUserRestriction = false;
    },
    openModalFilterUserRestrictedDocuments() {
      this.dialogFilterUserRestrictedDocuments = true;
    },
    closeModalFilterUserRestrictedDocuments() {
      this.dialogFilterUserRestrictedDocuments = false;
    },
    async deleteUserRestrictedDocuments(user) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title:
            "¿Estás seguro de eliminar la visualización de documentos de: " +
            user.full_name +
            `(${user.email}) ` +
            "?",
          text: "Esta acción no se puede deshacer",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            const resp = await this.changeUserRestrictionDocuments({
              email: user.email,
              document_viewer: false,
            });
            if (resp.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text:
                  "La visualización de documentos de: " +
                  user.name +
                  " ha sido eliminada correctamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
              this.getUserRestrictedDocumentsData();
            }
            this.loadingActions = false;
          }
        });
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      restrictedUsersDocuments: "document/userRestrictedDocuments",
    }),
  },
  watch: {
    "filters.page": function(page) {
      this.getUserRestrictedDocumentsData(page);
    },
  },
};
</script>

<style></style>
